<template>
  <div>
    <section id="sec01" class="mt-3" v-if="show_edit_option == false">
      <v-card color="secondary" class="mb-3">
        <v-card-text>
          <v-btn
            icon
            style="position:absolute;right:30px;top:1px;"
            :disabled="isEditProductList"
            @click="toEdit()"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            icon
            style="position:absolute;right:0px;top:1px;"
            :disabled="isEditProductList"
            @click="removeOption()"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <v-layout row wrap justify-center style="font-size:15px;">
            <v-flex xs5>
              Option name TH :
              <span class="text-data">{{ info.option_name_th }}</span>
              <br />Option type :
              <span class="text-data">{{
                info.option_type == 1 ? "Single" : "Multiple"
              }}</span>
              <br />
              <div v-if="info.option_require">
                Option required :
                <span class="text-data">{{
                  info.option_require ? "Require" : ""
                }}</span>
              </div>
            </v-flex>
            <v-flex xs1>
              <v-divider vertical></v-divider>
            </v-flex>
            <v-flex xs5>
              Choice
              <div class="text-data">
                <li v-for="(choice, index) in info.option_choice" :key="index">
                  {{ choice.choice_name_th }} &nbsp;&nbsp;
                  {{ parseFloat(choice.choice_price).toFixed(2) }} ฿
                </li>
              </div>
            </v-flex>
          </v-layout>
          <!--<span style="font-size:15px;">
             Option name TH :
            <span class="text-data">{{info.option_name_th}}</span> 
            <br>Option Type :
            <span class="text-data">{{info.option_type == 1 ? 'Single' : 'Multiple'}}</span>
            <br>Choice
            <div class="text-data">
              <li
                v-for="(choice,index) in info.option_choice"
                :key="index"
              >{{choice.choice_name_th}} &nbsp;&nbsp; {{parseFloat(choice.choice_price).toFixed(2)}} ฿</li>
            </div>
          </span>-->
        </v-card-text>
      </v-card>
    </section>

    <section id="sec02" v-if="show_edit_option == true">
      <v-form ref="formOption" v-model="valid">
        <v-card color="secondary" class="px-4">
          <v-card-title
            class="pb-0 justify-space-between"
            style="font-size:18px;font-weight:bold;"
            >Edit option</v-card-title
          >

          <v-layout row wrap class="pa-1">
            <v-flex xs4 class="pr-2">
              <v-text-field
                v-model="info.option_name_th"
                label="Option name TH"
                hide-details
                :rules="[(v) => !!v || 'name is required']"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="px-1">
              <v-text-field
                :rules="[(v) => !!v || 'name is required']"
                v-model="info.option_name_en"
                label="Option name EN"
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-2">
              <v-text-field
                v-model="info.option_name_cn"
                label="Option name CN"
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="my-4">
            <v-flex>
              <v-radio-group
                row
                v-model="info.option_type"
                class="mt-0 ml-3"
                hide-details
                :rules="[(v) => !!v || 'name is required']"
              >
                <div class="mr-2">Option Type :</div>
                <v-radio color="black" label="Single" :value="1"></v-radio>
                <v-radio color="black" label="Multiple" :value="2"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex>
              <v-checkbox
                v-model="info.option_require"
                class="mt-0 ml-3"
                label="Required this option."
                color="green"
                hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>

          <div v-for="(choice, index) in info.option_choice" :key="index">
            <v-layout row wrap>
              <v-flex xs6 sm3 class="pa-1">
                <v-text-field
                  class="mb-2"
                  outline
                  v-model="choice.choice_name_th"
                  label="Choice Name TH"
                  hide-details
                  :rules="[(v) => !!v || 'name is required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="pa-1">
                <v-text-field
                  class="mb-2"
                  outline
                  v-model="choice.choice_name_en"
                  label="Choice Name EN"
                  hide-details
                  :rules="[(v) => !!v || 'name is required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm3 class="pa-1">
                <v-text-field
                  outline
                  v-model="choice.choice_name_cn"
                  label="Choice Name CN"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs5 sm2 class="pa-1">
                <v-text-field
                  outline
                  v-model="choice.choice_price"
                  label="Price"
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs1 class="text-xs-center">
                <v-icon
                  medium
                  @click="info.option_choice.push({})"
                  color="green"
                  style="padding-top:20px;"
                  v-if="index == 0"
                  >add_circle</v-icon
                >
                <v-icon
                  medium
                  @click="removeChoice(info, choice, index)"
                  color="red"
                  style="padding-top:20px;"
                  v-if="index != 0"
                  >remove_circle</v-icon
                >
              </v-flex>
            </v-layout>
          </div>

          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn depressed @click="cancel()" v-if="editedIndex == -1"
              >Cancel</v-btn
            >
            <v-btn depressed @click="save()" :disabled="isEditProductList"
              >Save</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["info", "editedIndex"],
  data() {
    return {
      valid: true,
      original_data: null,
      show_edit_option: false,
    };
  },
  computed: {
    ...mapGetters(["isEditProductList"]),
  },
  methods: {
    async removeOption() {
      // if(this.editedIndex == -1){
      this.$emit("removeOption", this.info);
      // } else {
      //     this.$emit('fetchProductListBack/delOption')
      // }
    },
    async removeChoice(info, choice, index) {
      if (choice.choice_id) {
        let checkSuccess = await this.$store.dispatch(
          "fetchProductListBack/delChoice",
          choice.choice_id
        );
        if (checkSuccess == true) {
          info.option_choice.splice(index, 1);
        }
      } else {
        info.option_choice.splice(index, 1);
      }
    },
    stringEmptyToNull(form) {
      for (let val in form) {
        if (typeof form[val] == "string" && form[val] == "") {
          form[val] = null;
        }
        if (typeof form[val] == "object" && form[val] != null) {
          for (let arr in form[val]) {
            for (let val1 in form[val][arr]) {
              if (
                typeof form[val][arr][val1] == "string" &&
                form[val][arr][val1] == ""
              ) {
                form[val][arr][val1] = null;
              }
              if (
                typeof form[val][arr][val1] == "object" &&
                form[val][arr][val1] != null
              ) {
                for (let arr2 in form[val][arr][val1]) {
                  for (let val2 in form[val][arr][val1][arr2]) {
                    if (
                      typeof form[val][arr][val1][arr2][val2] == "string" &&
                      form[val][arr][val1][arr2][val2] == ""
                    )
                      form[val][arr][val1][arr2][val2] = null;
                  }
                }
              }
            }
          }
        }
      }
      return form;
    },
    async save() {
      if (this.$refs.formOption.validate()) {
        this.show_edit_option = false;
        if (this.info.option_id) {
          this.info = await this.stringEmptyToNull(this.info);
          let checkSuccess = await this.$store.dispatch(
            "fetchProductListBack/editCurrentOption",
            this.info
          );
          if (checkSuccess == false) {
            Object.assign(this.info, this.original_data);
          }
        }
      }
    },
    toEdit() {
      this.show_edit_option = true;
      this.original_data = JSON.parse(JSON.stringify(this.info));
    },
    cancel() {
      if (this.editedIndex == -1) {
        Object.assign(this.info, this.original_data);
      }
      this.show_edit_option = false;
      this.original_data = null;
    },
  },
};
</script>

<style>
.text-data {
  color: grey;
}
</style>
